import css from "./section.module.css";
import WindowDimensions from "./windowDimensions";

function Section(props) {
  const { height, width } = WindowDimensions();
  const alignCenter =
    props.sectionStyle === "alignCenter" ? css.alignCenter : null;

  const spaceBetween =
    props.sectionStyle === "spaceBetween" ? css.spaceBetween : null;

  const small = props.sectionStyle === "small" ? css.small : null;

  const bottomMargin = props.largeBottomMargin ? css.largeBottomMargin : null;

  const column = props.column && width < 736 ? css.column : null;

  return (
    <div>
      <div
        className={`${css.section} ${alignCenter} ${spaceBetween} ${small} ${column}`}
      >
        {props.children}
      </div>
      <div className={bottomMargin}></div>
    </div>
  );
}

export default Section;
